import "esbuild-css-modules-plugin-ns-css:src/ui/shared-styles.module.css";

export default {
  "button": "shared-styles-module__button_Y_AOrq__0230",
  "header": "shared-styles-module__header_Y_AOrq__0230"
};
      